import React from 'react';
import PageSizeSelector from '@shared/components/PageSizeSelector';
import SearchBar from '@shared/components/SearchBar';
import Pagination from '@shared/components/Pagination';
import LoadingButton from '@shared/components/LoadingButton';
import { useAddUsersByGroupModal } from '@modules/users/hooks/useAddUsersByGroupModal';

export default function AddUsersByGroup({ onClose, groupId }) {
    const {
        modalRef,
        selectedUsers,
        saving,
        filteredData,
        loading,
        error,
        pageNumber,
        pageSize,
        sortDir,
        totalElements,
        totalPages,
        searchQuery,
        searchType,
        searchOptions,
        handleCheckboxChange,
        handleSave,
        handleSort,
        setSearchQuery,
        setSearchType,
        setPageSize,
        setpageNumber,
        handleSearchClick,
        getData,
        t
    } = useAddUsersByGroupModal({ onClose, groupId });

    return (
        <div className="modal show" tabIndex="-1">
            <div ref={modalRef} className="form-wrapper top-20 width-80">
                <div className="form">
                    <h2 className="title">{t('nav.administrator.adminSection.addUsers')}</h2>

                    <div className="controls-section">
                        <div className="table-actions">
                            <SearchBar 
                                getData={getData}
                                searchOptions={searchOptions}
                                sortBy={'username'}
                                searchQuery={searchQuery}
                                searchType={searchType}
                                setSearchQuery={setSearchQuery}
                                setSearchType={setSearchType}
                                handleSearchClick={handleSearchClick}
                                setpageNumber={setpageNumber}
                            />
                        </div>

                        <PageSizeSelector
                            pageSize={pageSize}
                            setPageSize={setPageSize}
                            setpageNumber={setpageNumber}
                        />
                    </div>

                    <div className="table-responsive custom-table-container">
                        <table className="table table-hover">
                            <thead>
                                <tr>
                                    <th className="checkbox-column">
                                        <div className="checkbox-wrapper">
                                        </div>
                                    </th>
                                    <th onClick={() => handleSort('username')} className="sortable-header">
                                        {t('users.table.headers.username')}
                                        <span className="sort-indicator">
                                            {sortDir === 'asc' ? ' ↑' : ' ↓'}
                                        </span>
                                    </th>
                                    <th>{t('users.table.headers.accountname')}</th>
                                    <th>{t('users.table.headers.description')}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    <tr>
                                        <td colSpan="4" className="text-center">Loading...</td>
                                    </tr>
                                ) : error ? (
                                    <tr>
                                        <td colSpan="4" className="text-center text-danger">{error}</td>
                                    </tr>
                                ) : filteredData.length === 0 ? (
                                    <tr>
                                        <td colSpan="4" className="text-center">No users available to add</td>
                                    </tr>
                                ) : (
                                    filteredData.map((user) => (
                                        <tr key={user.id}>
                                            <td className="checkbox-column" onClick={(e) => e.stopPropagation()}>
                                                <div className="checkbox-wrapper">
                                                    <input
                                                        type="checkbox"
                                                        checked={selectedUsers.includes(user.id)}
                                                        onChange={() => handleCheckboxChange(user.id)}
                                                    />
                                                </div>
                                            </td>
                                            <td>{user.username}</td>
                                            <td>{user.fullname}</td>
                                            <td>{user.description}</td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                        <Pagination
                            pageNumber={pageNumber}
                            totalPages={totalPages}
                            totalElements={totalElements}
                            pageSize={pageSize}
                            setpageNumber={setpageNumber}
                        />
                    </div>

                    <div className="form-controls-container">
                        <LoadingButton
                            className="form-btn btn-blue"
                            onClick={handleSave}
                            loading={saving}
                            disabled={selectedUsers.length === 0}
                        >
                            {t('common.save')}
                        </LoadingButton>
                        <button
                            type="button"
                            className="form-btn btn-red"
                            onClick={() => onClose(false)}
                        >
                            {t('common.cancel')}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}